export default "__VITE_ASSET__Dg_fy6DI__"